import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/NewsListView.vue"),
  },
  {
    path: "/news/:id",
    name: "newsPage",
    component: () =>
      import(/* webpackChunkName: "newPage" */ "../views/NewsPageView.vue"),
  },
  {
    path: "/knowledge",
    name: "knowledge",
    component: () =>
      import(
        /* webpackChunkName: "knowledge" */ "../views/KnowledgeListView.vue"
      ),
  },
  {
    path: "/knowledge/:id",
    name: "knowledgePage",
    component: () =>
      import(
        /* webpackChunkName: "knowledgePage" */ "../views/KnowledgePageView.vue"
      ),
  },
  {
    path: "/doctors",
    name: "doctors",
    component: () =>
      import(/* webpackChunkName: "doctors" */ "../views/DoctorListView.vue"),
  },
  {
    path: "/hours",
    name: "hours",
    component: () =>
      import(/* webpackChunkName: "hours" */ "../views/HourView.vue"),
  },
  {
    path: "/services",
    name: "services",
    component: () =>
      import(/* webpackChunkName: "services" */ "../views/ServiceListView.vue"),
  },
  {
    path: "/services/:id",
    name: "servicePage",
    component: () =>
      import(
        /* webpackChunkName: "servicePage" */ "../views/ServicePageView.vue"
      ),
  },
  {
    path: "/progress",
    name: "progress",
    component: () =>
      import(/* webpackChunkName: "progress" */ "../views/ProgressView.vue"),
  },
  {
    path: "/traffic",
    name: "traffic",
    component: () =>
      import(/* webpackChunkName: "traffic" */ "../views/TrafficView.vue"),
  },
  {
    path: "/error-page",
    name: "errorPage",
    component: () =>
      import(/* webpackChunkName: "errorPage" */ "../views/ErrorView.vue"),
  },
  {
    path: "*",
    redirect: "/error-page",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（例如瀏覽器的前進/後退），返回該位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否則滾動到頂部
      return { x: 0, y: 0 };
    }
  },
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

export default router;
